import React from 'react';
import { QueryHookOptions } from '@apollo/client';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import { useQuery } from '@ts-gql/apollo';

export const GET_ENTITIES_BY_IDS_QUERY = gql`
  query GetEntitiesByIds($cloudIds: [String!]!) {
    getEntitiesByIds(cloudIds: $cloudIds) {
      cloudId
      name
      endDateUtc
      isDeleted
      entityTypeId
      familyGroupId
    }
  }
` as import('../../__generated__/ts-gql/GetEntitiesByIds').type;

export type GetEntitiesByIdsQueryVariables = OperationVariables<
  typeof GET_ENTITIES_BY_IDS_QUERY
>;
export type GetEntitiesByIdsQueryResult = OperationData<
  typeof GET_ENTITIES_BY_IDS_QUERY
>;

export type GetEntitiesByIdsItem = NonNullable<
  ReturnType<typeof processData>
>[number];

export const useGetEntitiesByIds = (
  options: QueryHookOptions<
    GetEntitiesByIdsQueryResult,
    GetEntitiesByIdsQueryVariables
  >
) => {
  const variables = options.variables as GetEntitiesByIdsQueryVariables;

  const res = useQuery(GET_ENTITIES_BY_IDS_QUERY, {
    context: { service: 'clients' },
    variables,
    ...options,
  });

  const { data } = res;
  return React.useMemo(
    () => ({ ...res, data: data ? processData(data) : null }),
    [res, data]
  );
};

export function processData(data: GetEntitiesByIdsQueryResult) {
  const rawRows = data?.getEntitiesByIds;
  const result: GetEntitiesByIdsQueryResult['getEntitiesByIds'] | undefined =
    rawRows?.map((raw) => ({
      ...raw,
      endDateUtc: raw.endDateUtc && new Date(raw.endDateUtc),
    }));
  return result;
}
